import { CSSProperties } from "react";
import { SystemElement, SystemGroup } from "../../../ReactData/system";
import { Direction } from "leaflet";
import { System, SystemDetails } from "@ews/react-data";



export type Alignment = "right" | "left" | "top" | "bottom";

export type ShowToolTipLabelBackgroundClasses = "show" | "hide";

//TODO: einbauen übersetzungs keys

export const alignments: Alignment[] = ["right", "left", "top", "bottom"] as const;
export const AlignmentsTranslationKey =
{
    "right": "[REACT_RIGHT]",
    "left": "[REACT_LEFT]",
    "top": "[REACT_TOP]",
    "bottom": "[REACT_BOTTOM]",
};

export const FontWeightsTranslationKey =
{
    "bold": "[REACT_FONT_WEIGHTS_BOLD]",
    "bolder": "[REACT_FONT_WEIGHTS_BOLDER]",
    "normal": "[REACT_FONT_WEIGHTS_NORMAL]",
    "lighter": "[REACT_FONT_WEIGHTS_LIGHTER]",
};
export const labelPosition: Alignment[] = ["right", "left", "top", "bottom"] as const;
export const fontWeights: CSSProperties["fontWeight"][] = ["bold", "bolder", "normal", "lighter"] as const;
export const labelBackground: ShowToolTipLabelBackgroundClasses[] = ["show", "hide"];

export const fontFamilies: { label: string, class: string; }[] = [
    { label: "Cursive", class: "cursive" },
    { label: "Times New Roman", class: "times-new-roman" },
    { label: "Franklin Gothic Medium", class: "franklin-gothic-medium" },
    { label: "Verdana", class: "verdana" },
    { label: "Segoe UI", class: "segoe-ui" },
    { label: "Courier New", class: "courier" }
] as const;


/* export type FontStyle = {
    fontSize?: number;
    fontWeight?: CSSProperties["fontWeight"];
    fontFamily?: CSSProperties["fontFamily"];
    labelPosition?: Alignment;
    label?: string;
    iconScale?: number;
};
 */
/* export type Element = c &
{ systemPlanStyle?: FontStyle; }; */

type Events = {
    onAlignment?: (elements: SystemElement[]) => void;
    onChange?: (element: SystemElement, modified: { [key: string]: any; }) => void;
    onSelect?: (element: SystemElement) => void;
    onDelete?: (element: SystemElement) => void;
    onChangeTooltipDirection?: ({ direction, tooltipId }: { direction: Direction, tooltipId: number; }) => void;
};

export type ElementProps = {
    selectedElements: SystemElement[],
    defaultStyle?: SystemDetails["defaultPlanStyle"];
    element: SystemElement;
    group: SystemGroup;
    planHeight?: number;
    planWidth?: number;
    zoom?: number;
    selected?: boolean;
    allowedFlashEvents?: number;
    showLabel?: boolean;
    mapWidth?: number;
    mapHeight?: number;
    hasFloodingZone?: System["hasFloodingZone"];
} & Events;